// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_jw-0";